<template>
	<sf-content-layout>
		<template v-slot:location>
			<sf-location :locations="locations" />
		</template>
		<template v-slot:title>
			<sf-content-title :title="getMessage_(screen.menuTitle)" useFavorite :favorite="screen.favoriteYn === 'Y'" :onFavorite="onFavorite" />
		</template>
		<template v-slot:titleEnd>
			<!-- register common lang code -->
			<sf-button v-if="isButton_(scrId, 'CU')" :onClick="registerLangCode">{{ getMessage_('SWCC000998') }} </sf-button>
		</template>
		<template v-slot:content>
			<center-content :scrId="scrId" />
		</template>
	</sf-content-layout>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@common/CommonCode/store/helpers';

import CenterContent from './Content/Content.vue';
export default {
	components: { CenterContent },
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return {
			screen: {}
		};
	},
	created() {
		this.screen = this.screenArray.get(this.scrId);
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		locations() {
			let result = [];
			if (this.screen && this.screen.menuLocation) {
				result = this.screen.menuLocation.map(str => this.getMessage_(str));
			}

			return result;
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		onFavorite() {
			this.$sf_toggleLoading(true);
			this.onFavorite_()
				.then(header => {
					this.$sf_showMessage({
						...this.$sf_setMessageOption(header),
						message: this.getMessage_(header.messageCd) !== '' ? this.getMessage_(header.messageCd) : header.message
					});
				})
				.catch(error => {
					this.$sf_showMessage({ title: 'Error', icon: 'error', message: error.message });
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		},
		registerLangCode() {
			const { currentPage, pageUnit } = this.commCdLangModal.groups;
			this.$sf_toggleLoading(true);
			this.selectCommCdLangList_({ currentPage, pageUnit }).finally(() => {
				this.$sf_toggleLoading(false);
			});

			this.SET({ key: 'commCdLangModal', value: { ...this.commCdLangModal, show: true, isButtonOpened: true } });
		}
	},
	beforeDestroy() {
		this.resetState_();
	}
};
</script>

<style></style>
